import styled from "styled-components";

export const GridWrapper = styled.div`
  display: flex;
  overflow-x: hidden;
`;
